import React, { useState } from 'react';
import styled from 'styled-components';
import { UserInfo } from '@ibinder/common-frontend';
import { ThemeButton, Card } from '@ibinder/ui-common-core';

import { impersonateUser } from '../AdminActionBar/index';
import ImpersonateUserModal from '../AdminActionBar/ImpersonateUserModal';
import { useIBTranslation } from '@ibinder/ui-common-hooks';

const UserList = styled.ul`
  padding: 0;
`;

const UserCard = styled.li`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const OrganizationImpersonate = ({ organization, type }) => {
  const [selectedUser, setSelectedUser] = useState(null);

  if (organization.data?.get?.organization?.id) {
    localStorage.setItem('tenantId', organization.data?.get?.organization?.id);
  }

  const { t } = useIBTranslation();

  if (!organization.data?.get) {
    return <Card loading={true} />;
  }

  const organizationData = organization.data.get;

  return (
    <>
      {selectedUser && (
        <ImpersonateUserModal
          targetUserId={selectedUser.userId}
          userName={selectedUser.name}
          onClose={() => setSelectedUser(null)}
          onImpersonated={(token) =>
            impersonateUser(
              token,
              selectedUser.name,
              selectedUser.userEmail,
              selectedUser.userId,
              organization.data?.get,
              organization.data?.get?.organization?.id
            )
          }
        />
      )}
      <UserList>
        {organizationData.admins.map((user) => {
          return (
            <UserCard key={user.id}>
              <UserInfo
                size={'small'}
                fullName={user.name}
                email={user.userEmail}
              ></UserInfo>
              <ThemeButton
                buttonType="default"
                onClick={() => setSelectedUser(user)}
              >
                {t('impersonate')}
              </ThemeButton>
            </UserCard>
          );
        })}
      </UserList>
    </>
  );
};

export default OrganizationImpersonate;
